import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_PATH + '/',
  timeout: 15000,
  withCredentials: true,
})

// Intercept Request
api.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// Intercept Error Response
api.interceptors.response.use(
 
  response => {
    if (parseFloat(response.headers['app-version']) > parseFloat(process.env.VUE_APP_VERSION)) {
    
      location.reload(true);
    }
    return response
  },
  function (error) {   
    return Promise.reject(error)
  }
)

export default api
